
import Dialog from '@mui/material/Dialog';
import { Component } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogTitleWithCloseButton from './DialogTitleWithCloseButton';
import { countAtomicProducts } from '../../../shared/utils';
import { TextField } from '@mui/material';
import { errorToast } from '../toast';

export default class SerialNumbersInput extends Component {

   state = {
      serialNumbers: []
   }

   createdTextBoxId(productId, pos) {
      return `txt-serial-no-${productId}-${pos}`
   }

   save = () => {
      const payload = [];

      for (const product of this.state.serialNumbers) {

         const serial_numbers = [];

         for (let i = 0; i < product.serial_numbers.length; i++) {
            const serialNo = product.serial_numbers[i];
            if (!serialNo) {
               errorToast("All fields must be populated");
               const elemId = this.createdTextBoxId(product._id, i)
               return document.getElementById(elemId).focus();
            }

            serial_numbers.push(serialNo);
               
         }

         payload.push({
            product: product._id,
            serial_numbers,
         })
      }

      this.props.onClose(payload);

   }

   componentDidMount() {
      const products = countAtomicProducts(this.props.product);

      const serialNumbers = products.map(({ product, quantity}) => {
         return {
            _id: product._id,
            name: product.name,
            serial_numbers: new Array(quantity).fill('')
         }
      });

      this.setState({ serialNumbers });
   }

   render() {
      return <Dialog open maxWidth="xs" fullWidth>
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Serial Numbers
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className='flex flex-col'>
               {
                  this.state.serialNumbers.map(product => {
                     return <div className='flex flex-col gap-4 py-4 border-b border-gray-300 last:border-none'>
                        <div className='truncate'>
                           {product.name}
                        </div>
                        {
                           product.serial_numbers.map((serialNumber, index) => {
                              return <TextField
                                 id={this.createdTextBoxId(product._id, index)}
                                 size='small'
                                 placeholder='Serial No'
                                 variant='outlined'
                                 value={serialNumber}
                                 onChange={e => {
                                    const { value } = e.target;
                                    const serialNumbers = this.state.serialNumbers.map(_product => {
                                       if (_product !== product)
                                          return _product;

                                       const serial_numbers = product.serial_numbers.map((_serialNumber, _index) => {
                                          if (_index !== index)
                                             return _serialNumber;
                                          return value;
                                       });

                                       return { ...product, serial_numbers }
                                    });

                                    this.setState({ serialNumbers });
                                 }}
                              />
                           })
                        }
                     </div>
                  })
               }
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.save}>
               SAVE
            </Button>
         </DialogActions>
      </Dialog>
   }
}